import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['delaySelect', 'kioskLink', 'launchButton', 'copyButton', 'qrCodeFrame']
  static values = { qrCodeUrl: String }

  handleDelayChange() {
    const kioskUrl = this.kioskUrl()
    this.kioskLinkTarget.innerText = kioskUrl
    this.copyButtonTarget.setAttribute('data-text-to-copy', kioskUrl)

    const url = new URL(this.qrCodeUrlValue, window.location.origin)
    url.searchParams.set('path', kioskUrl)
    this.qrCodeFrameTarget.src = url.toString()
  }

  launch() {
    window.location.assign(this.kioskUrl())
  }

  kioskUrl() {
    const baseURL = new URL(this.launchButtonTarget.getAttribute('data-kiosk-base-url'))
    const delay = this.delaySelectTarget.value
    if (delay) {
      baseURL.searchParams.append('delay', this.delaySelectTarget.value)
    }
    return baseURL.toString()
  }
}
